import React from "react";
import PropTypes from "prop-types";

export const FooterText = props => (
  <span>
  {/* Home   |   Contact    |   Lead From Purpose - © 2020 */}
  Lead From Purpose - © 2020
  </span>
);

FooterText.propTypes = {
  anchor: PropTypes.string.isRequired,
  rtlActive: PropTypes.bool
};
